import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ContentSimple } from '../ContentSimple';

import useStyles from './useStyles';

const ContentOutline = ({ className, content, onChange, onFocusChange, disabled, setEditor }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      {content.map((row, index) => (
        <div
          className={styles.row}
          key={row.id}
        >
          <Typography className={styles.title}>{row.title}</Typography>

          <ContentSimple
            className={styles.content}
            index={index}
            content={row.value}
            onChange={onChange}
            onFocusChange={onFocusChange}
            disabled={disabled}
            disableNewlines
            setEditor={setEditor}
          />
        </div>
      ))}
    </div>
  );
};

ContentOutline.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func,
  disabled: PropTypes.bool,
  setEditor: PropTypes.func,
};

ContentOutline.defaultProps = {
  className: null,
  onFocusChange: null,
  disabled: false,
  setEditor: null,
};

export default ContentOutline;
